<template>
  <div>
    <o-section :overlay="true" v-if="!onlyArrival">
      <o-text-input label="Vertrek">
        <div class="u-flex">
          <o-text-input
            icon="date"
            type="date"
            class="u-flex__flexible"
            value="2019-06-24"
          />
          <o-text-input
            icon="clock"
            type="time"
            class="u-flex__flexible"
            value="10:00"
          />
        </div>
      </o-text-input>
    </o-section>
    <o-section :overlay="true">
      <o-text-input label="Aankomst">
        <div class="u-flex">
          <o-text-input
            icon="date"
            type="date"
            class="u-flex__flexible"
            value="2019-06-24"
            :readonly="onlyArrival"
          />
          <o-text-input
            icon="clock"
            type="time"
            class="u-flex__flexible"
            value="17:00"
          />
        </div>
      </o-text-input>
    </o-section>
  </div>
</template>

<script>
export default {
  name: 'OEditTime',
  props: {
    onlyArrival: {
      type: Boolean,
      default: false
    }
  }
}
</script>
